var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"loadingState":_vm.loadingState,"type":"button"},on:{"click":_vm.handleClick,"myevent":_vm.my}},[(_vm.loadingState)?_c('span',{staticClass:"spinner-grow spinner-grow-sm",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e(),_c('span',{class:_vm.loadingState ? 'visually-hidden' : ''},[_vm._t("label")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }